module.exports = __webpack_public_path__ + "img/leftbicep-ecto-mesomorph-female.4bb0f025.svg";